export default __webpack_public_path__ + "static/media/EmptyProjects.8effcf98.svg";